import React from 'react';

export default function ProcessList() {
  return (
    <va-process-list>
      <va-process-list-item header="Check your eligibility">
        <p>
          Entitlement restoration can only be granted for certain education
          benefits.
        </p>
        <ul>
          <li>Post-9/11 GI Bill (Chapter 33)</li>
          <li>
            Survivors' and Dependents' Educational Assistance (DEA) Program
            (Chapter 35)
          </li>
          <li>Montgomery GI Bill (MGIB) (Chapter 30)</li>
          <li>Montgomery GI Bill - Selected Reserve (Chapter 1606)</li>
        </ul>
      </va-process-list-item>
      <va-process-list-item header="Gather your information">
        <h4>Here’s what you’ll need to apply:</h4>
        <ul>
          <li>Your social security number or your VA file number</li>
          <li>Your current mailing address and contact information</li>
          <li>
            The name and mailing address of the institution where the program or
            school was suspended, withdrawn or closed.
          </li>
          <li>The date of your withdrawal from the school or program.</li>
          <li>If applicable, the name of your new school and program.</li>
        </ul>
      </va-process-list-item>
      <va-process-list-item header="Complete your application">
        <p>
          The request should take about 15 minutes to complete. You can include
          any additional information you think is relevant in your request to
          have your entitlement restored.
        </p>
        <p>
          <strong>Note:</strong> When you fill out your form, you will be asked
          for your address. When you update your address, your VA Profile
          address will also update.
        </p>
      </va-process-list-item>
      <va-process-list-item header="Upload your form">
        <p>
          When you click submit, your completed form will be sent directly and
          securely to VA through our online submission system.
        </p>
        <p>
          After submitting, you'll receive a confirmation email. Keep this
          confirmation for your records.
        </p>
        <p>
          If your submission cannot be processed electronically, VA will contact
          you with instructions on next steps.
        </p>
      </va-process-list-item>
    </va-process-list>
  );
}
